<script setup lang="ts">
import { inject, ref } from 'vue'
import { useToast as usePrimeToast } from 'primevue/usetoast'
import { updateUserPassword } from '~/layers/cms/app/composables/cms'

const toast = usePrimeToast()
const dialogRef = inject<DialogRef>('dialogRef')
const newPassword = ref<string>('')

interface DialogRef {
  value: {
    data: {
      choosenUserId: number
    }
    close(): void
  }
}

const closeDialog = () => {
  if (!dialogRef) return
  dialogRef.value.close()
}

const updatePassword = async () => {
  if (!dialogRef || !dialogRef.value.data.choosenUserId || !newPassword.value) return
  const response = await updateUserPassword(dialogRef.value.data.choosenUserId, newPassword.value)
  if (!response.status_ok) {
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Nie udało się zaaktualiować hasła usera',
      life: 3000
    })
  } else {
    toast.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Poprawnie zaaktualizowano hasło usera',
      life: 3000
    })
    closeDialog()
  }
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <label>
      Wpisz nowe hasło:
      <InputText
        v-model="newPassword"
        type="password"
        required
      />
    </label>
    <Button
      type="button"
      label="Zapisz"
      severity="primary"
      @click="updatePassword"
    />
  </div>
</template>
